import { call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import userAPI from '../../../../user/api/UserAPI';
import { FETCH_USER_CARRIER_SELECTIONS_REQUEST, DELETE_USER_CARRIER_SELECTION_REQUEST } from '../../../../user/redux/actions/types/UserActionTypes';
import {
  fetchUserCarrierSelectionsFailureActionCreator,
  fetchUserCarrierSelectionsSuccessActionCreator,
  deleteUserCarrierSelectionFailureActionCreator,
  deleteUserCarrierSelectionSuccessActionCreator,
} from '../../../../user/redux/actions/UserActions';
import { postCarrier } from '../../api/CarriersApi';
import {
  carrierCheckedActionCreator,
  retrieveOutboundCarriersFailureActionCreator,
  retrieveOutboundCarriersSuccessActionCreator,
} from '../actions/CarrierActions';
import { RETRIEVE_OUTBOUND_CARRIER_REQUEST } from '../actions/types/CarrierActionTypes';

function* retrieveOutboundCarrierWorker(action) {
  const stretch = 'OUTBOUND';
  try {
    const carriersResponse = yield call(postCarrier, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(retrieveOutboundCarriersSuccessActionCreator(carriersResponse.data));

    if (action.checkedCarriers && action.checkedCarriers.length) return;

    const lastUserCarrierSelectionResponse = yield call(userAPI.getLastUserCarrierSelection);
    const lastUserCarrierSelection = lastUserCarrierSelectionResponse.data;

    if (lastUserCarrierSelection) {
      yield put(carrierCheckedActionCreator(lastUserCarrierSelection.carriers));
    }
  } catch (error) {
    yield put(retrieveOutboundCarriersFailureActionCreator(error));
  }
}

function* fetchUserCarrierSelectionsWorker() {
  try {
    const userCarrierSelectionsResponse = yield call(userAPI.getUserCarrierSelections);
    const selections = userCarrierSelectionsResponse.data;

    yield put(fetchUserCarrierSelectionsSuccessActionCreator(selections));
  } catch (error) {
    yield put(fetchUserCarrierSelectionsFailureActionCreator(error));
  }
}

function* deleteUserCarrierSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserCarrierSelection, action.payload);
    yield put(deleteUserCarrierSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserCarrierSelectionFailureActionCreator(error));
  }
}

function* carriersWatcher() {
  yield takeLeading(RETRIEVE_OUTBOUND_CARRIER_REQUEST, retrieveOutboundCarrierWorker);
  yield takeLeading(FETCH_USER_CARRIER_SELECTIONS_REQUEST, fetchUserCarrierSelectionsWorker);
  yield takeEvery(DELETE_USER_CARRIER_SELECTION_REQUEST, deleteUserCarrierSelectionsWorker);
}

export default carriersWatcher;
